import { module } from 'angular';
import templateBuilderTextFieldDisplay from './builder/display.html';
import templateBuilderTextFieldData from './builder/data.html';
import templateBuilderTextFieldValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/textfield/display.html', templateBuilderTextFieldDisplay);
	$templateCache.put('kform/components/textfield/data.html', templateBuilderTextFieldData);
	$templateCache.put('kform/components/textfield/validate.html', templateBuilderTextFieldValidate);
});
